import { CopyOutlined } from '@ant-design/icons'
import { Button, Card, message, Typography } from 'antd'
import React from 'react'
import { useParams } from 'react-router-dom'
import { useWorkstationQuery } from './query'
import './styles.scss'
import { clipboard } from '~/utils/helpers'

const { Title, Paragraph, Text } = Typography

const WorkstationInfo = () => {
  const { token } = useParams()
  const {
    data: workstation,
    isLoading,
    isError,
    error
  } = useWorkstationQuery(token)

  if (isError) {
    return (
      <div className='workstation-form'>
        <Card variant='outlined' style={{ width: 350 }}>
          <Title level={3}>Error</Title>
          <Paragraph>
            {error.response?.data?.message ||
              'Server error, please try again later'}
          </Paragraph>
        </Card>
      </div>
    )
  }

  return (
    <div className='workstation-form'>
      <Title className='student-alias' level={3} style={{ marginBottom: 40 }}>
        {workstation?.student.alias}
      </Title>
      <Card variant='outlined' style={{ width: 350 }} loading={isLoading}>
        <Title style={{ margin: 10, marginBottom: 40 }}>
          <a
            href={workstation?.workstationUrl}
            target='_blank'
            rel='noreferrer'
          >
            <Button
              className='workstation-url'
              type='primary'
              size='large'
              shape='round'
            >
              Open workstation
            </Button>
          </a>
        </Title>

        {workstation?.student?.username && (
          <Paragraph>
            <Text style={{ marginRight: 20 }}>Username:</Text>
            <Text strong style={{ marginRight: '10px' }}>
              {workstation?.student?.username}
            </Text>
            <Button
              type='icon'
              icon={<CopyOutlined />}
              onClick={() => {
                clipboard(workstation?.student?.username)
                message.success('Copied')
              }}
            />
          </Paragraph>
        )}
        <Paragraph>
          <Text style={{ marginRight: 20 }}>Password:</Text>
          <Text strong style={{ marginRight: '10px' }}>
            {workstation?.student?.password}
          </Text>
          <Button
            type='icon'
            icon={<CopyOutlined />}
            onClick={() => {
              clipboard(workstation?.student?.password)
              message.success('Copied')
            }}
          />
        </Paragraph>
      </Card>
    </div>
  )
}

WorkstationInfo.propTypes = {}

export default WorkstationInfo
